import { Theme } from './symbols';

export const workableTheme: Theme = {
    name: 'workable',
    properties: {
        '--corecolour': '#333e49',
        '--corecolour1': '#333e49',
        '--corecolour-hover': '#1f262d',
        '--secondarycolour': '#00776b',
        '--secondarycolour-hover': '#004d45',
        '--secondarycolour-mild': '#59aea5',
        '--checkbox-indcolour': '#00776b',
        '--matformfield-colour': '#00776b',
        '--sidetoggle-gradient1': '#333e49',
        '--sidetoggle-gradient2': '#333e49',
        '--fab-gradient1': '#00776b',
        '--fab-gradient2': '#00776b',
        '--actionbutton-gradient1': 'red',
        '--actionbutton-gradient2': 'maroon',
        '--divider-gradient1': 'rgb(27, 142, 241)',
        '--divider-gradient2': 'rgb(27, 142, 241)',
        //Admin Gradient 
        '--admin-gradient1': '#333e49',
        '--admin-gradient2': '#333e49',
    }
};
